import { render, staticRenderFns } from "./SystemHelp.vue?vue&type=template&id=094a10bb&scoped=true&"
import script from "./SystemHelp.vue?vue&type=script&lang=ts&"
export * from "./SystemHelp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094a10bb",
  null
  
)

export default component.exports